<template>
    <div class="activity-content">
        <div class="activity-banner">
            <img src="../../assets/images/a-jfsc-banner@2x.png" alt />
            <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.push('/activity')"></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年5月15日-2020年9月30日</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item-row">
                            上海农商银行个人信用卡主卡持卡人  
                            <!-- <a
                                href="javascript:;"
                                @click="e=>{this.$test('FIVE-register-1'); this.$listeners.routePusht('/details/tjx')} "
                                class="apply-activity-btn"
                            ></a> -->
                        </div>
                         <!-- @click="e=>$listeners.routePusht('/details/xcb')"  -->
                        <div class="apply-button-wrapper"> 
                             <a href="javascript:;" class="apply-activity-btn"  @click="e=>this.$router.push('/credit')"  ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item-wrap">
                <div class="a-list-block">
                    <div class="left-item">
                        <img src="../../assets/images/jfsc-icon-1@2x.png" class="a-item-icon" alt />
                    </div>
                    <div class="right-item">
                        <h5>活动内容</h5>
                        <div class="text-item-warp">
                            <div class="text-item">
                                <p>活动期间，持卡人通过小福鑫积分平台，首次任意下单并完成支付，即可获得一次抽奖机会，随机获得奖品池中的奖品一份，奖品限6000份，送完即止</p>
                            </div>
                          
                           
                        </div>
                      
                    </div>

                </div>
                 <img src="../../assets/images/jfsc-table@2x.png" class="jfsc-table" alt="">
                <!-- <div class="a-block">
                    <span class="line"></span>

                    <div class="tjyl-tip">
                        <h5>注意事项</h5>
                        <p>1. 本活动仅限上海农商银行钛金鑫卡、世界白金鑫卡持卡人参与,消费类型限线上交易。</p>
                        <p>2. 同一客户活动期内,当期消费积分累计上限为当期账单周期账户信用额度的5倍,同一客户指按同一身份证号区别的本行信用卡主卡客户,附属卡消费并入主卡账户统一计算。</p>
                        <p>3. 积分赠送示例：客户A的授信额度为8万,其在活动期内,当期账单线上消费金额为1万元,则客户活动赠送5倍积分即5万分,客户A实际获得5万分。客户B的授信额度为2万,该客户当期账单线上消费金额为3万元(溢缴款消费),则客户活动赠送5倍积分为15万分,由于赠送积分封顶值为信用额度的五倍,故可赠送10万分,该客户B实际获得10万分。</p>
                        <p>本积分活动依需遵循本行账户积分规则执行。活动期间,如遇我行举办的其他同类型积分活动,则活动不做叠加,我行默认持卡人参加积分倍数高的活动。</p>
                    </div>
                </div>-->
            </div>

            <div class="a-list-item a-footer-item jfsc-footer-item">
                <div class="rule-details">
                    <h5>活动细则</h5>
                    <div class="rule-text">
                        <p>1、本次活动限上海农商银行个人信用卡主卡（除鑫智白金卡、白金商务卡、商务卡、鑫成卡、鑫福农卡、鑫风卡、优享白金鑫卡随鑫专用卡、优享白金鑫卡分期专用卡、鑫驰白金卡车牌分期专用卡、增值服务通个人卡外）的持卡人参与。</p>
                        <div class="more-text" v-show="isShow">
                            <p>2、本次活动所指的同一持卡人包括但不限于同一银行卡卡号、同一身份证号、同一微信账号、同一手机号、同一手机识别码等满足任一条件或其他可视为同一持卡人的情形。</p>
                            <p>3、本次活动所指的首次下单是指2020年尚未在小福鑫积分平台有过支付成功的订单记录（含积分兑换订单、分期订单、取消、退货订单），持卡人可以前往小福鑫积分平台我的订单查看历史订单记录。每位持卡人仅限参与一次。</p>
                            <p>4、未完成支付的订单不能参与活动，下单后取消或退货的订单，上海农商银行有权在活动期间或活动结束后进行扣减。</p>
                            <p>5、持卡人完成抽奖后，奖品兑换信息将于抽奖后的三个自然日内以短信方式发送至该持卡人预留的手机号中。</p>
                            <p>6、若因供应商停产等因素无法供应商品的，上海农商银行将以等值商品替换，最终解释权归上海农商银行所有。</p>
                            <p>7、本次活动的礼品不能兑换现金或其他商品，亦不能在无质量问题的情况下要求更换。上海农商银行不是商品的生产商或供应商，商品的任何质量问题、售后服务均由商品供应商负责。如出现供应商无法解决的商品质量问题，上海农商银行将协助持卡人与商品供应商进行交涉。</p>
                            <p>8、本次活动的交易统计时间、交易金额以上海农商银行信用卡后台结算系统记录的交易时间为准。</p>
                            <p>9、持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                            <p>10、如发现持卡人有利用活动规则或系统漏洞、作弊、冒用他人信息参与活动、进行虚假交易或者违法交易等手段恶意套取优惠奖励的，上海农商银行保留取消该持卡人参加本活动的权利，并有权取消或收回其因参加本活动所获的回馈和奖励。</p>
                            <p>11、在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等）公告后生效。</p>
                            <p>12、其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》及其他相关文件约束。</p>
                            <p>13、活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。在法律许可范围内，上海农商银行保留活动最终解释权。</p>

                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { isShow: false };
    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            // this.$test("recommend a-detail-2");
        }
    }
};
</script>

<style lang="scss" scoped>
</style>